export const DryMassEntryTestConfig = {
  ContainerLabel: {
    label: 'Tare ID',
  },
  ContainerMass: {
    uom: 'g',
    label: 'Tare Mass',
  },
  TareAndMaterialWetMass: {
    uom: 'g',
    label: 'Tare and Material Wet Mass',
  },
  MaterialWetMass: {
    uom: 'g',
    label: 'Material Wet Mass',
  },
  DateTimeInOven: {
    label: 'Date and Time in Oven',
  },
  DryMassBalance: {
    label: 'Dry Mass Balance',
  },
  [`DryMassReadings.DateTimeOutOfOven`]: {
    label: 'Date and Time Out of Oven',
  },
  [`DryMassReadings.DryingTime`]: {
    label: 'Drying Time',
    uom: 'h',
  },
  [`DryMassReadings.TareAndMaterialDryMass`]: {
    uom: 'g',
    label: 'Tare and Material Dry Mass',
  },
  [`DryMassReadings.MaterialDryMass`]: {
    uom: 'g',
    label: 'Material Dry Mass',
  },
  MoistureContent: {
    label: 'Moisture Content',
    uom: '%',
  },
};
